export const sendMessageToParent = (message: any) => {
  window?.parent?.postMessage(message, '*')
}
